define.alias("shared/components/shared/upgrade/mobile-upgrade-modal", "settings/components/shared/upgrade/mobile-upgrade-modal");